'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBemReact = require('@yandex-lego/i-bem-react');

var _iconReact = require('./../icon/icon.react.js');

var _iconReact2 = _interopRequireDefault(_iconReact);

require('./../control/control.react.js');

var _controlReact = require('./../../desktop.blocks/control/control.react.js');

var _controlReact2 = _interopRequireDefault(_controlReact);

var _link__innerReact = require('./__inner/link__inner.react.js');

var _link__innerReact2 = _interopRequireDefault(_link__innerReact);

var _link__iconReact = require('./__icon/link__icon.react.js');

var _link__iconReact2 = _interopRequireDefault(_link__iconReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = _iconReact2.default.applyDecls();

var Control = _controlReact2.default.applyDecls();

var LinkInner = _link__innerReact2.default.applyDecls();

var LinkIcon = _link__iconReact2.default.applyDecls();

exports.default = (0, _iBemReact.decl)(Control, {
    block: 'link',
    tag: function tag(_ref) {
        var url = _ref.url;

        return url ? 'a' : 'span';
    },
    mods: function mods(_ref2) {
        var size = _ref2.size,
            theme = _ref2.theme,
            nonvisual = _ref2.nonvisual,
            inner = _ref2.inner;

        return _extends({}, this.__base.apply(this, arguments), {
            size: size,
            theme: theme,
            inner: (0, _iBemReact.bool2string)(inner),
            nonvisual: (0, _iBemReact.bool2string)(nonvisual)
        });
    },
    attrs: function attrs(_ref3) {
        var id = _ref3.id,
            name = _ref3.name,
            title = _ref3.title,
            target = _ref3.target,
            rel = _ref3.rel,
            tabIndex = _ref3.tabIndex,
            style = _ref3.style,
            url = _ref3.url,
            _attrs = _ref3.attrs;
        var disabled = this.state.disabled;


        if (target === '_blank') {
            if (rel && rel.indexOf('noopener') === -1) {
                rel = rel + ' noopener'; // Пользовательский атрибут имеет больший приоритет
            }
        }

        return _extends({}, this.__base.apply(this, arguments), {
            id: id,
            name: name,
            title: title,
            style: style,
            target: target,
            rel: rel,
            href: url,
            role: url ? undefined : 'button',
            tabIndex: disabled ? url ? -1 : undefined : tabIndex,
            'aria-disabled': disabled ? 'true' : undefined
        }, _attrs);
    },
    content: function content(_ref4) {
        var text = _ref4.text,
            icon = _ref4.icon,
            iconLeft = _ref4.iconLeft,
            iconRight = _ref4.iconRight,
            children = _ref4.children;

        var content = [],
            innerElems = [],
            hasIconFromContent = this._hasIconFromContent(this.props),
            icons = [icon, iconLeft, iconRight].filter(Boolean),
            needSetSide = text || icons.length > 1; // Side не устанавливается, если иконка единственный элемент

        _react.Children.forEach(children, function (child, i) {
            if (Icon.isIcon(child)) {
                var onlyIcon = _react.Children.count(children) === 1;
                var side = onlyIcon ? '' : i === 0 ? 'left' : 'right';
                content.push(_react2.default.createElement(LinkIcon, { key: 'icon-' + i, side: side, children: child }));
            } else if (child) {
                // Undefined protection
                if (!innerElems.length) {
                    content.push(hasIconFromContent ? _react2.default.createElement(
                        LinkInner,
                        { key: 'inner' },
                        innerElems
                    ) : innerElems);
                }
                innerElems.push(child);
            }
        });
        if (content.length) {
            return content;
        }

        icon && content.unshift(_react2.default.createElement(LinkIcon, { key: 'icon-default', side: needSetSide ? 'left' : '',
            children: Icon.isIcon(icon) ? icon : _react2.default.createElement(Icon, icon) }));
        iconLeft && content.unshift(_react2.default.createElement(LinkIcon, { key: 'icon-side-left', side: needSetSide ? 'left' : '',
            children: Icon.isIcon(iconLeft) ? iconLeft : _react2.default.createElement(Icon, iconLeft) }));
        if (text) {
            if (!innerElems.length) {
                var hasIconFromFields = this._hasIconFromFields(this.props);
                content.push(hasIconFromFields ? _react2.default.createElement(
                    LinkInner,
                    { key: 'inner' },
                    innerElems
                ) : innerElems);
            }
            innerElems.push(text);
        }
        iconRight && content.push(_react2.default.createElement(LinkIcon, { key: 'icon-side-right', side: needSetSide ? 'right' : '',
            children: Icon.isIcon(iconRight) ? iconRight : _react2.default.createElement(Icon, iconRight) }));
        return content;
    },
    _hasIconFromContent: function _hasIconFromContent(_ref5) {
        var children = _ref5.children;

        return _react.Children.toArray(children).some(function (child) {
            return Icon.isIcon(child);
        });
    },
    _hasIconFromFields: function _hasIconFromFields(_ref6) {
        var icon = _ref6.icon,
            iconLeft = _ref6.iconLeft,
            iconRight = _ref6.iconRight;

        return icon || iconLeft || iconRight;
    }
}, {
    propTypes: {
        theme: _propTypes2.default.string.isRequired,
        pseudo: _propTypes2.default.bool,
        nonvisual: _propTypes2.default.bool,
        id: _propTypes2.default.string,
        url: _propTypes2.default.string,
        target: _propTypes2.default.string,
        title: _propTypes2.default.string,
        name: _propTypes2.default.string,
        tabIndex: _propTypes2.default.string,
        text: _propTypes2.default.string,
        icon: _propTypes2.default.object,
        iconLeft: _propTypes2.default.object,
        iconRight: _propTypes2.default.object,
        onClick: _propTypes2.default.func,
        rel: _propTypes2.default.string
    },
    defaultProps: {
        onClick: function onClick() {},

        tabIndex: '0'
    }
});